(function () {
  'use strict';

  /* ── Reading progress bar ──────────────────────────── */
  var bar = document.getElementById('reading-progress');
  if (bar) {
    function tick() {
      var s = document.documentElement.scrollTop || document.body.scrollTop;
      var h = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      bar.style.width = (h > 0 ? (s / h) * 100 : 0) + '%';
    }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* ── Read time ─────────────────────────────────────── */
  var contentEl  = document.querySelector('.article__content');
  var readTimeEl = document.getElementById('article-read-time');
  if (contentEl && readTimeEl) {
    var words = ((contentEl.innerText || contentEl.textContent || '').match(/\S+/g) || []).length;
    readTimeEl.textContent = Math.max(1, Math.ceil(words / 200)) + ' min read';
  }

  /* ── Table of Contents ─────────────────────────────── */
  var tocNav = document.getElementById('toc-nav');
  if (!contentEl || !tocNav) return;

  var headings = Array.from(contentEl.querySelectorAll('h2, h3'));

  if (headings.length < 2) {
    var sidebar = document.querySelector('.article-enhanced__sidebar');
    if (sidebar) sidebar.style.display = 'none';
    var layout = document.querySelector('.article-enhanced');
    if (layout) layout.style.gridTemplateColumns = '1fr';
    return;
  }

  var ul = document.createElement('ul');
  headings.forEach(function (h, i) {
    if (!h.id) {
      h.id = 'h' + i + '-' + (h.textContent || '')
        .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    var li = document.createElement('li');
    if (h.tagName === 'H3') li.classList.add('toc-h3');
    var a  = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.dataset.tocLabel || h.textContent;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      h.scrollIntoView({ behavior: 'smooth' });
      history.replaceState(null, '', '#' + h.id);
    });
    li.appendChild(a);
    ul.appendChild(li);
  });
  tocNav.appendChild(ul);

  /* Active section highlight via IntersectionObserver */
  var links = Array.from(tocNav.querySelectorAll('a'));
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      links.forEach(function (l) { l.classList.remove('toc-active'); });
      var active = tocNav.querySelector('a[href="#' + entry.target.id + '"]');
      if (active) active.classList.add('toc-active');
    });
  }, { rootMargin: '-4% 0px -92% 0px', threshold: 0 });

  headings.forEach(function (h) { io.observe(h); });
}());
